module.exports = __webpack_public_path__ + "static/img/feature_3.7098f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/feature_3.png
// module id = tPv0
// module chunks = 0